import { render, staticRenderFns } from "./addAMenu.vue?vue&type=template&id=1287c164"
import script from "./addAMenu.vue?vue&type=script&lang=js"
export * from "./addAMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports